

module.exports={
    BACKEND_URL:"https://api.potoq.in"
    //BACKEND_URL:"http://localhost:3000"
}